import { Theme } from "@commonlibs";
import { createGlobalStyle } from "styled-components";
import { FormControlStyles } from "./components/FormControl.styles";
import { TabsStyles } from "./components/Tabs.styles";
import { SelectStyles } from "./components/Select.styles";
import { TextInputStyles } from "./components/TextInput.styles";
import { TypographyStyles } from "./components/Typography.styles";
import { CheckboxStyles } from "./components/Checkbox.styles";
import "./fonts.css";
import { ButtonStyles } from "./components/Button.styles";
import { RootStyles } from "./Root.styles";
import { LinkStyles } from "./components/Link.styles";
import { TextFieldStyles } from "./components/TextField.styles";
import { ScrollBarStyles } from "./components/Scrollbar.styles";
import { DividerStyles } from "./components/Divider.styles";
import { ProgressBarStyles } from "./components/ProgressBar.styles";
import { ExpandableStyles } from "./components/Expandable.styles";
import { BackdropStyles } from "./components/Backdrop.styles";

export const GlobalStyles = createGlobalStyle<{ theme: Theme }>`
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    vertical-align: baseline;
    scroll-behavior: smooth;
  }

  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  html {
    color: #121212;
    font-family: Montserrat;
    font-size: clamp(14px, 1.5vw, 16px);
  }

  * {
    box-sizing: border-box;
    font-family: inherit;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
    color: inherit;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  strong {
    font-weight: 500;
  }

  body, html, #root {
     height: 100%;
  }
 

  a {
    text-decoration: none;
  }

  ${RootStyles}

  //Cumstom components
  ${BackdropStyles}
  ${ButtonStyles}
  ${CheckboxStyles}
  ${DividerStyles}
  ${ExpandableStyles}
  ${FormControlStyles}
  ${LinkStyles}
  ${ProgressBarStyles}
  ${ScrollBarStyles}
  ${SelectStyles}
  ${TabsStyles}
  ${TextFieldStyles}
  ${TextInputStyles}
  ${TypographyStyles}

`;
